import { FC } from 'react'
import { usePrevious } from 'react-use'

import { DialogActions, DialogContent, DialogContentText, Dialog as MuiDialog } from '@mui/material'

import { DialogButton } from './dialog-button'

export const ComplexDialog: FC<{
  content: string | undefined
  preventContent?: boolean
  loading?: boolean
  cancel: {
    text: string
    onClick: () => void
  }
  confirm: {
    text: string
    onClick: () => void
  }
}> = (props) => {
  const { preventContent = true } = props
  const previousContent = usePrevious(props.content)
  return (
    <MuiDialog open={props.content !== undefined} onClose={props.cancel.onClick}>
      <DialogContent>
        <DialogContentText align="center">{props.content ?? (preventContent && previousContent)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogButton variant="secondary" onClick={props.cancel.onClick}>
          {props.cancel.text}
        </DialogButton>
        <DialogButton variant="primary" loading={props.loading} onClick={props.confirm.onClick}>
          {props.confirm.text}
        </DialogButton>
      </DialogActions>
    </MuiDialog>
  )
}
